// Library Class
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
// Service Class
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { CppService } from './../../../services/cpp/cpp.service';
import { CommonService } from './../../../services/common/common.service';

// Class
import { MasterConstants } from './../../../common/constants/master-constants';
import { DashboardFilter } from './../../../models/DashboardFilter';
import { CPPLandingFilterVM } from './../../../models/CPP/CPPLandingFilterVM';
import { SelectionModel } from '@angular/cdk/collections';
import { ConfirmDialogComponent } from './../../../common/components/confirm-dialog/confirm-dialog.component';
import { NgbDate, NgbCalendar, NgbDateStruct, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { DialogComponent } from './../../../common/components/dialog/dialog.component';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-cpp-error-order-maintenance-dashboard.component',
  templateUrl: './cpp-error-order-maintenance-dashboard.component.html',
  styleUrls: ['./cpp-error-order-maintenance-dashboard.component.scss']
})
export class CppErrorOrderMaintenanceDashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('errorCPPOrdersTable', { read: MatSort }) errorCPPOrdersSort: MatSort;
  @ViewChild('errorCPPOrdersPaginator', { read: MatPaginator }) errorCPPOrdersPaginator: MatPaginator;

  private subscription = new Array<Subscription>();

  // selectedRow: any;
  selectedCount = 0;
  public erroredSelection = new SelectionModel<any>(true, []);
  public errorCPPOrdersDataSource: MatTableDataSource<any>;
  errorCPPOrdersList: any = [];
  headerCompany = MasterConstants.US_COMPANYCODE;
  dashboardFilter: DashboardFilter;
  errorCPPOrdersFooterColumns: string[] = [];
  errorCPPOrdersColumns: string[] = ['releaseId', 'webOrderNumber', 'purchaseOrderNumber', 'accountName', 'accountNumber', 'orderCreateDate', 'requestDeliveryDate', 'successfullyProcessed'];
  accountList: any;
  validateEvolveData: any;
  readOnlyAccess = false;
  isEvolveAccountRestriction = false;
  selectedValue: string;
  filterValueList = new Array();
  searchTypeList: string[] = [];
  fromRequestedDeliveryDateFilter: any;
  toRequestedDeliveryDateFilter: any;
  fromOrderDateFilter: any;
  toOrderDateFilter: any;
  productFilters: any;
  itemList: any = [];
  filter: CPPLandingFilterVM = new CPPLandingFilterVM();
  tabNode = '';
  delDate: any;
  ddlAccounts: any[] = [];
  processingStatusList: any = [
    { id: 'E', value: 'MasterData' },
    { id: 'F', value: 'Integration Error' },
    { id: 'B', value: 'Mulesoft/Azure' }
  ];
  showTabs = false;
  isWeekend = (date: NgbDate) => this.calendar.getWeekday(date) >= 6;
  datemodel: NgbDateStruct;
  isRequestedDateUpdate = false;

  constructor(
    private router: Router,
    private calendar: NgbCalendar,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private toastrService: ToastrService,
    private matDialog: MatDialog,
    private datePipe: DatePipe,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar,
    private cppService: CppService,
    private commonService: CommonService) {
    this.dashboardFilter = new DashboardFilter();
  }

  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.CPP_ERROR_CONFIG_MESSAGE)) {
      this.delDate = JSON.parse(this.localStorageService.get(MasterConstants.CPP_ERROR_CONFIG_MESSAGE))[0].value;
    }
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      this.isEvolveAccountRestriction = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany).evolveAccountRestriction;
    }

    if (this.headerCompany != undefined && this.isEvolveAccountRestriction == true) {
      this.subscription.push(this.commonService.getFilterDDLData().subscribe(result => {
        this.ddlAccounts = result.accounts;
      }, error => LolLoggerService.error(error)));
    }

    this.setSearchTypeList();
    this.resetPageFilter();
    this.getCppOrders();
    this.initializeDeliveryDate();

    this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_ERROR_ORDER_MAINTENANCE);

    this.subscription.push(this.cppService.getCppItemNumberList().subscribe((result: any[]) => {
      this.itemList = result;
    }));
  }

  // initialize Delivery Date min values
  initializeDeliveryDate() {
    const currentDate = new Date();
    this.config.minDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() };
    this.datemodel = this.configDate.getToday();
    this.tabNode = '';
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  // set account table height
  setAccSummaryTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.cppTopSec').outerHeight() - $('.form-sec').outerHeight() - $('.fulfill-top-sec').outerHeight() - 120;
      $('.growertableContainer').css('max-height', templateHeight + 'px');
    }, 100);
  }

  // Reset Page Filter
  resetPageFilter() {
    this.productFilters = {
      'ItemNo': [],
      'ProductName': null,
      'AccountName': null,
      'TxtAccountNo': null,
      'AccountNo': [],
      'FromRequestedDeliveryDate': null,
      'ToRequestedDeliveryDate': null,
      'FromOrderDate': null,
      'ToOrderDate': null,
      'WinfieldReferenceNumber': null,
      'WebOrderNumber': null,
      'CustomerPONumber': null,
      'ProcessingStatus': null,
      'quoteNumber': null,
      'fromQuoteDate': null,
      'toQuoteDate': null,
      'fromCloseDate': null,
      'toCloseDate': null,
      'status': null,
      'BlanketOrderStatus': null,
      'BlanketOrderNumber': null,
      'FromBlanketOrderDate': null,
      'ToBlanketOrderDate': null
    };

    this.filter = {
      'itemNo': null,
      'productName': null,
      'accountName': null,
      'account': null,
      'fromRequestedDeliveryDate': null,
      'toRequestedDeliveryDate': null,
      'fromOrderDate': null,
      'toOrderDate': null,
      'winfieldReferenceNumber': null,
      'webOrderNumber': null,
      'customerPONumber': null,
      'processingStatus': null,
      'quoteNumber': null,
      'fromQuoteDate': null,
      'toQuoteDate': null,
      'fromCloseDate': null,
      'toCloseDate': null,
      'status': null,
      'blanketOrderStatus': null,
      'blanketOrderNumber': null,
      'fromBlanketOrderDate': null,
      'toBlanketOrderDate': null
    };
  }

  // Clear filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      this.removePageFilter(filterValue);
      if (this.filterValueList.length < 1) {
        this.getCppOrders();
      }
    }
    this.setAccSummaryTableHeight();
  }
  validateNumText(numInput) {
    const accountRegx = RegExp('^[0-9, ]+$');
    const isValidNumInput = accountRegx.test(numInput);
    if (!isValidNumInput) {
      this.toastrService.error('Invalid Input.');
      numInput = null;
    }
    return numInput;
  }
  // Validate the search input text
  validateInputText() {
    if (this.productFilters.TxtAccountNo) {
      this.productFilters.TxtAccountNo = this.validateNumText(this.productFilters.TxtAccountNo);
    }
    if (this.productFilters.WebOrderNumber) {
      this.productFilters.WebOrderNumber = this.validateNumText(this.productFilters.WebOrderNumber);
    }
    if (this.productFilters.CustomerPONumber) {
      this.productFilters.CustomerPONumber = this.validateNumText(this.productFilters.CustomerPONumber);
    }
  }

  // Keep Filter Value
  keepFilter(selectedObj: any, type: string) {
    this.validateInputText();
    if (this.filterValueList) {
      let selectedIds = '';
      if (selectedObj && selectedObj.selectedValues) {
        const selectedValues = selectedObj.selectedValues as any[];
        if (type == 'ItemNo') {
          selectedValues.forEach(x => { selectedIds = selectedIds + x.value + ','; });
        } else {
          selectedValues.forEach(x => { selectedIds = selectedIds + (type == 'AccountNo' ? x.accountNumber : x.id) + ','; });
        }
      }

      switch (type) {
        case 'ItemNo':
          this.filter.itemNo = selectedIds;
          break;

        case 'ProcessingStatus':
          this.filter.processingStatus = selectedIds;
          break;
      }

      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.ProductName && this.productFilters.ProductName != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.ProductName);
          this.filter.productName = this.productFilters.ProductName.trim();
        }
        // Set Item No
        if (this.productFilters.ItemNo && this.productFilters.ItemNo.length > 0) {
          let strIno = '';
          this.productFilters.ItemNo.forEach(x => {
            strIno = strIno + x + ', ';
          });
          this.filterValueList.push('Item No : ' + strIno.substr(0, strIno.length - 2));
        }

        // Set ProcessingStatus
        if (this.productFilters.ProcessingStatus && this.productFilters.ProcessingStatus.length > 0) {
          let strPs = '';
          this.productFilters.ProcessingStatus.forEach(x => {
            strPs = strPs + x + ', ';
          });
          this.filterValueList.push('Processing Status : ' + strPs.substr(0, strPs.length - 2));
        }

        // text Account No
        if (this.productFilters.TxtAccountNo && this.productFilters.TxtAccountNo != '') {
          this.filterValueList.push('Account No : ' + this.productFilters.TxtAccountNo);
          this.filter.account = this.productFilters.TxtAccountNo.trim();
        }
        else if (this.productFilters.AccountNo && this.productFilters.AccountNo.length > 0) {
          let strAct = '';
          this.productFilters.AccountNo.forEach(x => {
            strAct = strAct + x + ', ';
          });

          if (this.isEvolveAccountRestriction) {
            this.filterValueList.push('Account : ' + strAct.substr(0, strAct.length - 2));
          }
          else {
            this.filterValueList.push('Account No : ' + strAct.substr(0, strAct.length - 2));
          }

          // selectedIds = '';
          // this.accountList.forEach(x => {
          //  if (this.productFilters.AccountNo.indexOf(x.accountNumber) > -1) {
          //    selectedIds = selectedIds + x.accountNumber + ',';
          //  }
          // })
          if (this.productFilters.AccountNo == -1) {
            this.filter.account = '-1';
          }
          else {
            this.filter.account = strAct;
          }
        }
        else {
          this.filter.account = null;
        }

        // Account Name
        if (this.productFilters.AccountName && this.productFilters.AccountName != '') {
          this.filterValueList.push('Account Name : ' + this.productFilters.AccountName);
          this.filter.accountName = this.productFilters.AccountName.trim();
        }
        else {
          this.filter.accountName = null;
        }

        // Winfield Reference Number
        if (this.productFilters.WinfieldReferenceNumber && this.productFilters.WinfieldReferenceNumber != '') {
          this.filterValueList.push('Winfield Reference Number : ' + this.productFilters.WinfieldReferenceNumber);
          this.filter.winfieldReferenceNumber = this.productFilters.WinfieldReferenceNumber.trim();
        }

        // Web Order Number
        if (this.productFilters.WebOrderNumber && this.productFilters.WebOrderNumber != '') {
          this.filterValueList.push('Web Order Number : ' + this.productFilters.WebOrderNumber);
          this.filter.webOrderNumber = this.productFilters.WebOrderNumber.trim();
        } else {
          this.filter.webOrderNumber = null;
        }

        // Customer PO#
        if (this.productFilters.CustomerPONumber && this.productFilters.CustomerPONumber != '') {
          this.filterValueList.push('Customer PO# : ' + this.productFilters.CustomerPONumber);
          this.filter.customerPONumber = this.productFilters.CustomerPONumber.trim();
        } else {
          this.filter.customerPONumber = null;
        }

        if (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) {
          let strPL = '';
          this.productFilters.ProductLineList.forEach(x => {
            strPL = strPL + x + ', ';
          });
          this.filterValueList.push('Product Line : ' + strPL.substr(0, strPL.length - 2));
        }

        if (this.productFilters.FromOrderDate
          && this.productFilters.FromOrderDate != null
          && this.productFilters.ToOrderDate
          && this.productFilters.ToOrderDate != null) {
          this.filterValueList.push('Order Date : (' + this.datePipe.transform(this.productFilters.FromOrderDate, 'MM/dd/yyyy') + ') - (' + this.datePipe.transform(this.productFilters.ToOrderDate, 'MM/dd/yyyy') + ')');
          this.filter.fromOrderDate = new Date(this.productFilters.FromOrderDate).toDateString();
          this.filter.toOrderDate = new Date(this.productFilters.ToOrderDate).toDateString();
        }

        if (this.productFilters.FromRequestedDeliveryDate
          && this.productFilters.FromRequestedDeliveryDate != null
          && this.productFilters.ToRequestedDeliveryDate
          && this.productFilters.ToRequestedDeliveryDate != null) {
          this.filterValueList.push('Requested Arrival Date : (' + this.datePipe.transform(this.productFilters.FromRequestedDeliveryDate, 'MM/dd/yyyy') + ') - (' + this.datePipe.transform(this.productFilters.ToRequestedDeliveryDate, 'MM/dd/yyyy') + ')');
          this.filter.fromRequestedDeliveryDate = new Date(this.productFilters.FromRequestedDeliveryDate).toDateString();
          this.filter.toRequestedDeliveryDate = new Date(this.productFilters.ToRequestedDeliveryDate).toDateString();
        }
      }
      this.setAccSummaryTableHeight();
    }
  }

  // To remove clear search filter
  removePageFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Item No':
        this.productFilters.ItemNo = null;
        this.filter.itemNo = null;
        break;

      case 'Processing Status':
        this.productFilters.ProcessingStatus = null;
        this.filter.processingStatus = null;
        break;
      case 'Product Name':
        this.productFilters.ProductName = null;
        this.filter.productName = null;
        break;
      case 'Account No':
        if (this.isEvolveAccountRestriction) {
          this.productFilters.AccountNo = [];
        }
        else {
          this.productFilters.TxtAccountNo = null;
        }
        this.productFilters.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Account':
        if (this.isEvolveAccountRestriction) {
          this.productFilters.AccountNo = [];
        }
        else {
          this.productFilters.TxtAccountNo = null;
        }
        this.productFilters.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Account Name':
        this.productFilters.AccountName = null;
        this.filter.accountName = null;
        break;
      case 'Winfield Reference Number':
        this.productFilters.WinfieldReferenceNumber = null;
        this.filter.winfieldReferenceNumber = null;
        break;
      case 'Web Order Number':
        this.productFilters.WebOrderNumber = null;
        this.filter.webOrderNumber = null;
        break;
      case 'Customer PO#':
        this.productFilters.CustomerPONumber = null;
        this.filter.customerPONumber = null;
        break;
      case 'Requested Arrival Date':
        this.productFilters.FromRequestedDeliveryDate = null;
        this.productFilters.ToRequestedDeliveryDate = null;
        this.filter.fromRequestedDeliveryDate = null;
        this.filter.toRequestedDeliveryDate = null;
        this.fromRequestedDeliveryDateFilter = '';
        this.toRequestedDeliveryDateFilter = '';
        break;
      case 'Order Date':
        this.productFilters.FromOrderDate = null;
        this.productFilters.ToOrderDate = null;
        this.filter.fromOrderDate = null;
        this.filter.toOrderDate = null;
        this.fromOrderDateFilter = '';
        this.toOrderDateFilter = '';
        break;
      default:
        break;
    }
  }

  // Clear all filter
  clearAllFilter() {
    this.filterValueList = new Array();
    this.resetPageFilter();
    this.validateRequestedDeliveryDateFilter('clearAll', '');
    this.validateOrderDateFilter('clearAll', '');
    this.getCppOrders();
    this.setAccSummaryTableHeight();
  }

  // validate Scheduled Delivery Date for grid search
  validateRequestedDeliveryDateFilter(contextFrom, $event) {
    if (contextFrom == 'fromRequestedDeliveryDate') {
      fromDate = new Date($event.value);
      if (this.productFilters.ToRequestedDeliveryDate) {
        var toDate = new Date(this.productFilters.ToRequestedDeliveryDate);
        this.fromRequestedDeliveryDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate <= toDate;
        };
      }
      this.toRequestedDeliveryDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate >= fromDate;
      };
    }
    else if (contextFrom == 'toRequestedDeliveryDate') {
      toDate = new Date($event.value);
      this.fromRequestedDeliveryDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate <= toDate;
      };
      if (this.productFilters.FromRequestedDeliveryDate) {
        var fromDate = new Date(this.productFilters.FromRequestedDeliveryDate);
        this.toRequestedDeliveryDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate >= fromDate;
        };
      }
    }
    else if (contextFrom == 'clearAll') {
      this.fromRequestedDeliveryDateFilter = '';
      this.toRequestedDeliveryDateFilter = '';
    }
  }

  // validate Order Date for grid search
  validateOrderDateFilter(contextFrom, $event) {
    if (contextFrom == 'fromOrderDate') {
      fromDate = new Date($event.value);
      if (this.productFilters.ToOrderDate) {
        var toDate = new Date(this.productFilters.ToOrderDate);
        this.fromOrderDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate <= toDate;
        };
      }
      this.toOrderDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate >= fromDate;
      };
    }
    else if (contextFrom == 'toOrderDate') {
      toDate = new Date($event.value);
      this.fromOrderDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate <= toDate;
      };
      if (this.productFilters.FromOrderDate) {
        var fromDate = new Date(this.productFilters.FromOrderDate);
        this.toOrderDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate >= fromDate;
        };
      }
    }
    else if (contextFrom == 'clearAll') {
      this.fromOrderDateFilter = '';
      this.toOrderDateFilter = '';
    }
  }

  // Get account list
  getAccountData() {
    this.loaderService.setLoaderStatus(true);

    this.subscription.push(this.cppService.getShipToFacilityList().subscribe(result => {
      this.accountList = result;
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // Set search filters
  setSearchTypeList() {
    if (this.isEvolveAccountRestriction) {
      this.searchTypeList = ['Account', 'Product Name', 'Item Number', 'Order Date', 'Requested Arrival Date', 'Sales Order Number', 'Order ID', 'Customer PO#', 'Processing Status'];
    }
    else {
      this.searchTypeList = ['Account No', 'Account Name', 'Product Name', 'Item Number', 'Order Date', 'Requested Arrival Date', 'Sales Order Number', 'Order ID', 'Customer PO#', 'Processing Status'];
    }
    this.selectedValue = this.searchTypeList[0];
  }

  // Get Cpp orders list
  getCppOrders() {
    this.loaderService.setLoaderStatus(true);
    this.erroredSelection.clear();
    this.showTabs = false;

    this.subscription.push(this.cppService.getCppErrorOrdersList(this.filter).subscribe((result: any[]) => {
      this.errorCPPOrdersList = result;
      if (this.errorCPPOrdersList.length === 0) {
        this.errorCPPOrdersFooterColumns = [];
      } else {
        this.errorCPPOrdersFooterColumns = [
          'releaseId', 'accountName', 'accountNumber', 'webOrderNumber',
          'purchaseOrderNumber', 'orderCreateDate',
          'requestDeliveryDate', 'total', 'successfullyProcessed'];
      }
      this.errorCPPOrdersDataSource = new MatTableDataSource(this.errorCPPOrdersList);
      this.errorCPPOrdersDataSource.paginator = this.errorCPPOrdersPaginator;
      this.errorCPPOrdersDataSource.paginator.firstPage();
      this.errorCPPOrdersDataSource.sort = this.errorCPPOrdersSort;

      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  // return sum of amount for error orders
  getTotalOrdersBalance() {
    return this.errorCPPOrdersList.map(t => t.total).reduce((acc, value) => acc + value, 0);
  }

  // Navigate to selected order detail
  navigateOrderDetail(obj: any) {
    const accountNumber = 0;
    if (obj) {
      this.loaderService.setLoaderStatus(true);
      this.cppService.setCppOrderId(+obj.cppOrderId);
      this.router.navigate(['/cpp/error-order-maintenance']);
      this.loaderService.setLoaderStatus(false);
    }
  }

  // format Instruction Details for grid display
  getInstructionDetails(item) {
    const details = item.length > 10 ? item.substr(0, 10) + '....' : item;
    return details;
  }

  // All grid rows select/deselect using header checkbox
  masterToggleErrored() {
    this.isAllErroredSelected() ?
      this.erroredSelection.clear() :
      this.errorCPPOrdersDataSource.data.forEach(row => this.erroredSelection.select(row));
    this.selectedCount = this.erroredSelection.selected.length;
    this.showTabs = this.selectedCount > 0 ? true : false;
  }

  // retrun All grid rows selected or not
  isAllErroredSelected() {
    const numSelected = this.erroredSelection.selected.length;
    const numRows = this.errorCPPOrdersDataSource.data.length;
    return numSelected === numRows;
  }

  // Select/deselect checkbox of grid rows
  erroredOrderCheckEvent(row, isChecked: boolean) {
    this.erroredSelection.toggle(row);
    if (isChecked == true) {
      this.selectedCount = this.selectedCount + 1;
    }
    else {
      this.selectedCount = this.selectedCount - 1;
    }
    // this.selectedRow = row;
    this.showTabs = this.selectedCount > 0 ? true : false;
  }

  // Show/hide resubmite button
  showTab(tabid: string) {
    this.tabNode = tabid;
  }

  // set value in the selected order rows
  SetAllFields(field: string, value: any) {
    switch (field) {
      case 'deliverydate':
        (this.erroredSelection.selected.length > 0);
        {
          this.erroredSelection.selected.forEach(selectedOrder => {
            const currentLineIndex = this.errorCPPOrdersDataSource.data.findIndex(x => x.cppOrderId == selectedOrder.cppOrderId);

            if (currentLineIndex != -1) {
              this.isRequestedDateUpdate = true;
              this.errorCPPOrdersDataSource.data[currentLineIndex].requestDeliveryDate = JSON.parse(JSON.stringify(new Date(value.year, value.month - 1, value.day)));
              this.erroredOrderCheckEvent(this.errorCPPOrdersDataSource.data[currentLineIndex], false);
            }
          });
        }

        this.tabNode = '';
        this.selectedCount = 0;
        this.showTabs = false;
        break;
      default:
        break;
    }
  }

  // resubmit orders
  resubmitOrders() {
    const title = 'Confirmation';
    const message = 'Are you sure you want to resubmit ' + this.selectedCount + ' selected Orders(s)?';
    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '350px',
      data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
    });

    this.subscription.push(dialogRef.afterClosed().subscribe(yes => {
      if (yes == true) {// User selected Yes
        const resubmitOrderList: any = [];
        if (this.erroredSelection.selected.length > 0) {
          let resubmitOrderList: any = [];
          this.erroredSelection.selected.forEach(selectedOrder => {
            const newRow = {
              cppOrderId: selectedOrder.cppOrderId,
              webOrderNumber: selectedOrder.webOrderNumber,
              splitId: selectedOrder.splitId,
              successfullyProcessed: selectedOrder.successfullyProcessed,
              desiredDeliveryDate: this.isRequestedDateUpdate ? (new Date(selectedOrder.requestDeliveryDate)).toLocaleDateString('en-US').replace(/\u200E/g, '') : null,
            };
            resubmitOrderList.push(newRow);
          });

          resubmitOrderList = resubmitOrderList;

          this.loaderService.setLoaderStatus(true);

          this.subscription.push(this.cppService.resubmitOrdersList(resubmitOrderList).subscribe((result: any[]) => {
            if (result) {
              let status = '';
              result.forEach(x => {
                if (x.containsErrorSplit) {
                  status = status + 'Order#: ' + x.webOrderNumber + ' - ' + x.splitId + x.errorList;
                } else {
                  status = status + 'Order#: ' + x.webOrderNumber + ' - ' + x.splitId + ' processed successfully.';
                }
                status = status + '<br/>';
              });
              status = '<div class="padding-20">' + status + '</div>';
              const dialog = this.matDialog.open(DialogComponent, {
                data: {
                  title: 'Resubmission Status', content: status
                }
              });
            }
            this.getCppOrders();
            this.erroredSelection.clear();
            this.tabNode = '';
            this.selectedCount = 0;
            this.showTabs = false;
            this.loaderService.setLoaderStatus(false);
            this.isRequestedDateUpdate = false;
          }, error => { this.loaderService.setLoaderStatus(false); }));
        }
      } else {
      }
    }));
  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
